export default __webpack_public_path__ + "static/media/fi-trash.5dea380a.svg";